import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-login-mfa-signin',
  templateUrl: './mfa-signin.component.html',
  styleUrls: ['../login.component.css', './mfa-signin.component.css'],
  standalone: false,
})
export class MfaSigninComponent {
  // Context bridge to parent login component
  @Input() ctx: any;
  @Input() loading = false;

  constructor(public theme: ThemeService) {}
}
